import clsx from 'clsx'

import { Carousel } from 'api/fetchers/carousels/fetchCarousel'
import mainStyles from 'assets/css/main.module.scss'
import PracticionerCard from 'components/practicionerCard/PracticionerCard'
import Slider from 'components/slider/Slider'
import { AnalyticsActionType } from 'types/analytics.type'
import { ANALYTICS_EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './PractitionersCarousel.module.scss'

const PractitionersCarousel = ({ items }: { items: Carousel[] }) => {
  const practitioners = items.map(({ practitioner, tag }: Carousel, index) => (
    <PracticionerCard
      image={practitioner?.user?.image}
      name={`${practitioner?.user?.firstname}  ${practitioner?.user?.lastname}`}
      cluster={`${practitioner?.user?.country.cluster?.code} - ${practitioner?.user?.country?.cluster?.name}`}
      communityTag={tag?.name}
      associatedRole={practitioner?.user?.associateRole}
      showBubble={index === 0}
      showStar={index === 1}
      email={practitioner?.user?.email}
    />
  ))

  return (
    <div className={styles.practitionersCarouselWrapper}>
      <p className={clsx('pb-12', mainStyles.cokeRedH1, mainStyles['text-center'])}>We're Here to Help.</p>
      <Slider
        items={practitioners}
        slidesPerView={2.1}
        id="practitionersCarousel"
        className="w-full !px-[50px]"
        spacing={20}
        navigationNextAction={(page: number) => {
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CAROUSEL_RIGHT_ARROW_CLICKED,
              params: [
                {
                  key: 'page',
                  value: page.toString(),
                },
              ],
            },
          })
        }}
        navigationPrevAction={(page: number) => {
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CAROUSEL_LEFT_ARROW_CLICKED,
              params: [
                {
                  key: 'page',
                  value: page.toString(),
                },
              ],
            },
          })
        }}
        paginationUpdateAction={(page: number) =>
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CAROUSEL_DOT_CLICKED,
              params: [
                {
                  key: 'page',
                  value: page.toString(),
                },
              ],
            },
          })
        }
      />
    </div>
  )
}

export default PractitionersCarousel
